/* Host injection seam for the enterprise-local PurchaseAgent bundle.
 *
 * gtc-agent 의 ``gtcAgentSlot`` 과 같은 패턴이다. 구매 페이지는 enterprise 앱에
 * 있고 (PDF 렌더·업로드·XLSX 직렬화 등 host 의존), 공통 라우팅은 tenant-neutral
 * 이어야 하므로 host 가 bootstrap 시점에 컴포넌트를 주입한다.
 */

import type React from 'react';

export type PurchaseAgentModePageComponent = React.ComponentType;

let modePage: PurchaseAgentModePageComponent | null = null;

export function setPurchaseAgentModePageComponent(
  component: PurchaseAgentModePageComponent | null,
): void {
  modePage = component;
}

export function getPurchaseAgentModePageComponent(): PurchaseAgentModePageComponent | null {
  return modePage;
}

/* ── 목록 패널 오버라이드 — 선적 건 현황판 ─────────────────────────────
 * 구매 모드는 표준 워크스페이스/최근 항목 목록 대신 문서(선적 건) 단위
 * 현황판을 쓴다. WorkspaceModeLayout 이 이 슬롯이 차 있으면 기본
 * WorkspaceSidebar 대신 렌더한다. props 는 WorkspaceSidebar 와 같은 결. */

export interface PurchaseAgentPanelProps {
  pageSidebarOpen: boolean;
  onTogglePageSidebar: () => void;
}

export type PurchaseAgentPanelComponent = React.ComponentType<PurchaseAgentPanelProps>;

let panel: PurchaseAgentPanelComponent | null = null;

export function setPurchaseAgentPanelComponent(
  component: PurchaseAgentPanelComponent | null,
): void {
  panel = component;
}

export function getPurchaseAgentPanelComponent(): PurchaseAgentPanelComponent | null {
  return panel;
}
